<template>
  <i class="fa" :class="iconClass" aria-hidden="true" :style="{fontSize: fontSize}"></i>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props: {
            iconClass:{
                  type:String
            },
          fontSize:{
                type:String
          }
        },
        computed:{
        },
        methods: {}
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// icon.vue?447fbb3c